import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import { api } from '@/utils/api';
import { ArrowLeft, Search } from 'lucide-react';

const CustomerTracking = () => {
  const navigate = useNavigate();
  const [trackingData, setTrackingData] = useState({ order_id: '', first_name: '' });
  const [loading, setLoading] = useState(false);

  const handleTrack = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('order_id', trackingData.order_id);
      formData.append('first_name', trackingData.first_name);

      const response = await api.post('/track-tickets', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      localStorage.setItem('tracked_tickets', JSON.stringify(response.data));
      localStorage.setItem('tracking_info', JSON.stringify(trackingData));
      navigate('/customer/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'No tickets found with this Order ID and Name');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4 sm:p-6">
      <div className="w-full max-w-md">
        <Button variant="ghost" onClick={() => navigate('/')} className="mb-6 h-11" data-testid="back-btn">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Home
        </Button>

        <Card className="border-border shadow-lg">
          <CardHeader className="text-center">
            <div className="mx-auto h-16 w-16 rounded-full bg-accent/10 flex items-center justify-center mb-4">
              <Search className="h-8 w-8 text-accent" />
            </div>
            <CardTitle className="text-2xl font-heading">Track Your Tickets</CardTitle>
            <CardDescription>Enter your Order ID and Name to view ticket status</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleTrack} className="space-y-4">
              <div>
                <Label htmlFor="order-id">Order ID</Label>
                <Input
                  id="order-id"
                  data-testid="track-order-id-input"
                  placeholder="1198"
                  value={trackingData.order_id}
                  onChange={(e) => setTrackingData({ ...trackingData, order_id: e.target.value })}
                  required
                  className="mt-1.5 text-base h-11"
                />
              </div>
              <div>
                <Label htmlFor="first-name">Your Name</Label>
                <Input
                  id="first-name"
                  data-testid="track-name-input"
                  placeholder="Enter your first name"
                  value={trackingData.first_name}
                  onChange={(e) => setTrackingData({ ...trackingData, first_name: e.target.value })}
                  required
                  className="mt-1.5 text-base h-11"
                />
              </div>
              <Button type="submit" data-testid="track-submit-btn" disabled={loading} className="w-full h-11">
                {loading ? 'Searching...' : 'Track Tickets'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default CustomerTracking;
